import { SimpleQueryResponse } from './../../dtos/simpleQueryResponse';
import { APICONSTANTS } from './../../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FilterBpDTO } from '../../dtos/filterBpDTO';
import { catchError } from 'rxjs/operators';
import { BpModel } from '../../models/societe-linked/bp/bp.model';
import { SocieteLinkedService } from '../societe-linked/societe-linked.service';
import { BpValidationModel } from '../../dtos/bpValidationModel';
import { DashboardModel } from '../../dtos/dashboard.model';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class BpService extends SocieteLinkedService<BpModel> {

  observer = new BehaviorSubject<BpModel>(null);
  public bpSubscriber = this.observer.asObservable();

  constructor(protected http: HttpClient,
              protected toastrService: ToastrService,
              protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTEBP, hostnameService);
  }

  getFiltredBp(fitredto: FilterBpDTO): Observable<SimpleQueryResponse<BpModel>>{
  return  super.getAllFromObjet('getfiltredData/', fitredto).pipe(catchError( err => this.requestCatchError(err, 'Le chargement')));
  }

  toInvoice(t: BpModel): Observable<BpModel> {
    return this.http.post<BpModel>(APICONSTANTS.URLAPI.value + this.route + 'toInvoice', t)
      .pipe(catchError(err => this.requestCatchError(err, 'L\'enregistrement du brouillon')));
  }
  getDashboard(): Observable<DashboardModel> {
    return this.http.get<DashboardModel>(APICONSTANTS.URLAPI.value + this.route + 'GetDashboard')
        .pipe(catchError(err => this.requestCatchError(err, 'L\'affichage')));
  }

  getAuthorisation(codeCa1: string, idSociete: number): Observable<number[]> {
    // tslint:disable-next-line: max-line-length
    return this.http.get<BpModel>(APICONSTANTS.URLAPI.value + this.route + 'getAuthorisation?codeCa1=' + codeCa1 + '&idSociete=' + idSociete)
        .pipe(catchError(err => this.requestCatchError(err, 'Le chargement des droits')));
  }
  validateBp(bpForValidation: BpValidationModel): Observable<BpModel> {
    return this.http.put<BpModel>(APICONSTANTS.URLAPI.value + this.route + 'validate', bpForValidation)
        .pipe(catchError(err => this.requestCatchError(err, 'La validation')));
  }

  refusBp(bpForRefus: BpValidationModel): Observable<BpModel> {
    return this.http.put<BpModel>(APICONSTANTS.URLAPI.value + this.route + 'Refus', bpForRefus)
        .pipe(catchError(err => this.requestCatchError(err, 'Le refus')));
  }

  updateFacturation(bp: BpModel): Observable<BpModel> {
    return this.http.put<BpModel>(APICONSTANTS.URLAPI.value + this.route + 'updateFacturation', bp)
        .pipe(catchError(err => this.requestCatchError(err, 'La mise à jour')));
  }

  cancel(bp: BpModel): Observable<BpModel> {
    return this.http.post<BpModel>(APICONSTANTS.URLAPI.value + this.route + 'annulation', bp)
        .pipe(catchError(err => this.requestCatchError(err, 'L\'annulation')));
  }

  exportBps(filtre: FilterBpDTO) {
    return this.http.post(APICONSTANTS.URLAPI.value + this.route + 'exportBps', filtre, {responseType: 'text'}).pipe(catchError(err => this.requestCatchError(err, 'Export')));
}
}
